import { UiText, UiTextProps } from '@webfox-sc/core';
import React from 'react';

const FormElementLabel: React.FC<UiTextProps> = ({ ...props }) => {
  return <UiText variant="formElementLabel" color="ciBlue1" marginBottom="2px" {...props} />;
};

export default FormElementLabel;
